import { type AccessorFn, type SubmissionValueAccessorFn } from '../drupal-webform-types';

export const VALUE_ACCESSOR_MARKUP: AccessorFn = (_value, settings) =>
    !!settings?.markup && (settings.showMarkupOn === 'preview' || settings.showMarkupOn === 'all') ? settings.markup : undefined;

export const SUBMISSION_VALUE_ACCESSOR_SUBMITTING_MARKUP: SubmissionValueAccessorFn = (value, { name }) => ({
    [name]: value !== undefined,
});
